(function(){
  var style=document.createElement('style');
  style.textContent='[data-gwb-find] .gwbfind__more{flex:0 0 auto!important;width:auto!important;}';
  document.head.appendChild(style);

  function rows(els){
    var seen={},n=0;
    els.forEach(function(el){
      if(el.hidden)return;
      var t=el.offsetTop;
      if(!(t in seen)){seen[t]=1;n++}
    });
    return n;
  }

  function layout(group){
    var toggle=group.__toggle;
    if(!toggle)return;
    var chips=[].slice.call(group.querySelectorAll('.gwbchip'));
    if(!chips.length){toggle.hidden=true;return;}

    chips.forEach(function(c){c.hidden=false});
    toggle.hidden=true;

    if(group.__expanded){
      toggle.hidden=false;
      toggle.textContent=group.dataset.lessText||'Less';
      return;
    }

    var maxRows=2;
    if(rows(chips)<=maxRows)return;

    toggle.hidden=false;
    var visible=chips.length;

    while(visible>0){
      chips.forEach(function(c,i){c.hidden=i>=visible});
      if(rows(chips.concat([toggle]))<=maxRows)break;
      visible--;
    }

    toggle.hidden=false;
    toggle.textContent=group.dataset.moreText||'More';
  }

  document.querySelectorAll('[data-gwb-find] [data-gwb-group]').forEach(function(group){
    var old=group.__toggle;
    if(!old)return;

    var toggle=old.cloneNode(true);
    old.replaceWith(toggle);
    group.__toggle=toggle;
    group.__expanded=false;

    toggle.addEventListener('click',function(){
      group.__expanded=!group.__expanded;
      toggle.setAttribute('aria-expanded',group.__expanded?'true':'false');
      layout(group);
    });

    layout(group);

    var timer;
    window.addEventListener('resize',function(){
      clearTimeout(timer);
      timer=setTimeout(function(){layout(group)},150);
    });
  });
})();